<div class="tabcontent" [hidden]="!active"><ng-content></ng-content></div>